import { forwardRef, useState } from "react";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  Divider,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import RegisterFormHelp from "./RegisterFormHelp";

function RegisterFormRecommand(props) {

  const {setRname, setRphone} = props;
  const [open, setOpen] = useState(false);

  const closeClick = () => {
    setOpen(false);
  };

  const openClick = () => {
    setOpen(true);
  };

  return (
    <>
      <RegisterFormHelp open={open} closeClick={closeClick}></RegisterFormHelp>
      <Box
          sx={{
            fontWeight: "bold",
            marginBottom: "5px",
            display: "flex",
            alignItems: "center",
            marginTop: '3rem'
          }}
          onClick={openClick}
        >
          <Box sx={{ marginRight: "5px" }}>추천인 등록</Box>{" "}
          <Box sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px' }}>추천인 등록 혜택 안내</Box><HelpOutlineIcon fontSize="small" color="action" sx={{ width: '15px' }} />
        </Box>
      <Grid container width="100%">
        <TextField
          autoComplete="off"
          name="rname"
          label="추천인 이름"
          size="small"
          variant="standard"
          sx={{
            width: "100%",
            
          }}
          onChange={(e)=>{setRname(e.target.value)}}
        ></TextField>
      </Grid>
      <Grid container width="100%" marginBottom="10px" sx={{ mt: 0.5 }}>
        <TextField
          autoComplete="off"
          name="rphone"
          label="추천인 연락처"
          size="small"
          variant="standard"
          style={{
            width: "100%",
          }}
          onChange={(e)=>{setRphone(e.target.value)}}
        ></TextField>
      </Grid>
    </>
  );
}

export default RegisterFormRecommand;
